import { action, computed, makeObservable } from 'mobx';

import { IFormModel, IFormFieldOptions } from 'stores/interfaces';

import { Entry } from '../Entry';

type ToServerData<T> = T | null;

type EntrySelectValue<T extends string = string> = T | null;

type EntrySelectParams<T extends string = string> = Partial<
  IFormFieldOptions<EntrySelectValue<T>>
> & {
  options: T[];
};

/** Модель для поля-селекта */
export class EntrySelect<T extends string = string>
  extends Entry<EntrySelectValue<T>>
  implements IFormModel<any, ToServerData<T>>
{
  constructor(params: EntrySelectParams<T>) {
    super({
      ...params,
      defaultValue: params?.defaultValue || null,
    });
    this._options = params.options;

    makeObservable(this, {
      toServerFormat: computed,
      fromServerFormat: action,
    });
  }

  private readonly _options: T[];

  get options(): T[] {
    return this._options;
  }

  /**
   * Возвращает серверный формат значение поле
   * @returns {ToServerData} результат для отправки на сервер
   */
  get toServerFormat(): ToServerData<T> {
    return this.value;
  }

  /**
   * Заполняет значение поле из серверных данных
   * @param from серверные данные
   */
  fromServerFormat(from: EntrySelectValue<T>): void {
    this.setValue(from, { noTouch: true });
    this.unTouch();
  }
}
